// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { errorErrorsList } from 'redux/modules/notifications'
import StatusesTable from './StatusesTable'
import { getUsersAnalyses } from './helpers'
import { LoadingIcon } from 'components'
import { useAnalysisStatusesWrapper } from './hooks'

const Wrapper = props => {
  const {
    closeModal,
    idRoot,
  } = props

  const state = useAnalysisStatusesWrapper(props)

  return (
    <div
      className={'bg-blue-dark position-relative'}
      style={{ width: 1000 }}>
      <h3 className={'padding-half margin-0 text-white display-flex justify-content-between'}>
        <span id={`${idRoot}-modal-title`}>
          {'ANALYSIS STATUS'}
        </span>
        <i
          className={'fa fa-times pointer'}
          id={`${idRoot}-close-modal`}
          onClick={closeModal} />
      </h3>
      <StatusesTable
        closeModal={closeModal}
        data={state.usersAnalyses}
        idRoot={idRoot} />
      <LoadingIcon loading={state.isLoading} />
    </div>
  )
}

Wrapper.propTypes = {
  closeModal: func.isRequired,
  errorErrorsList: func.isRequired,
  getUsersAnalyses: func.isRequired,
  idRoot: string.isRequired,
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    errorErrorsList,
    getUsersAnalyses,
  }, dispatch)
)

export default connect(
  null,
  mapDispatchToProps,
)(Wrapper)
